import { type PaymentTargetInfo } from '@a1/shared';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Grid2 from '@mui/material/Grid2';

interface VoidDialogProps {
  open: boolean;
  onClose: () => void;
  onVoid: (invoiceId: number) => void;
  targetInfo: PaymentTargetInfo | null;
  customAlertMessage?: string;
  customTitle?: string;
  loading?: boolean;
}

const VoidDialog: React.FC<VoidDialogProps> = ({ open, onClose, onVoid, targetInfo, customTitle, loading }) => {
  const identifierToShow = targetInfo?.displayIdentifier || `ID: ${targetInfo?.id}`;
  const defaultTitle = `Void ${identifierToShow}`;

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h4">{customTitle || defaultTitle}</Typography>
      </DialogTitle>
      <DialogContent>
        <Grid2 size={12} mt={2}>
          <Alert severity="error">
            <b>Warning: This action is irreversible.</b> Voiding an invoice will cancel it permanently and mark it as void in the system.
          </Alert>
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button loading={loading} variant="contained" color="error" onClick={() => targetInfo && onVoid(Number(targetInfo.id))}>
          Void
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoidDialog;
